import { FC } from "react";
import { LayerGroup, Marker, Polyline } from "react-leaflet";
import { TripArcDTO } from "../../../../../datasources/api-client/data-contracts";
import { useChartColors } from "../../../../../theme/theme";
import { ThemeColors } from "../../../../../theme/themeValues";
import { tripNodeDivIcon } from "../../utils";

interface Props {
	arcs?: TripArcDTO[];
	onSelectedArc?: (id: number) => void;
}

const TripLayer: FC<Props> = ({ arcs, onSelectedArc }) => {
	const { chartColors } = useChartColors();

	if (!arcs || arcs?.length === 0) return <></>;

	const lines = arcs.map((arc) => {
		const startPosition = { lat: arc.origin.lat, lng: arc.origin.lng };
		const endPosition = { lat: arc.destination.lat, lng: arc.destination.lng };

		const color =
			arc.transportTypeId === 1
				? chartColors.roadType
				: arc.transportTypeId === 2
					? chartColors.trainType
					: arc.transportTypeId === 3
						? chartColors.shipType
						: arc.transportTypeId === 4
							? chartColors.airType
							: "#55555555";

		const pathOptions = {
			weight: 3,
			color: color,
		};

		return (
			<Polyline
				key={arc.id}
				positions={[startPosition, endPosition]}
				pathOptions={pathOptions}
				eventHandlers={onSelectedArc && { click: (e) => onSelectedArc(arc.id) }}
			/>
		);
	});

	const nodes = [arcs[0].origin];
	arcs.map((arc) => nodes.push(arc.destination));

	const markers = nodes.map((node, index) => {
		const nodeColor =
			index === 0
				? ThemeColors.LightWarning
				: index === nodes.length - 1
					? ThemeColors.LightSuccess
					: ThemeColors.LightAction;
		// const size = index === 0 || index === nodes.length - 1 ? 32 : 24;
		return (
			<Marker
				key={node.id}
				position={{ lat: node.lat, lng: node.lng }}
				icon={tripNodeDivIcon(node.typeId, nodeColor, 32)}
			/>
		);
	});

	return (
		<LayerGroup>
			{lines}
			{markers}
		</LayerGroup>
	);
};

export default TripLayer;
